var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMatchTransacion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Component 7"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_497_10653",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 26,
    height: 26
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 26,
    height: 26,
    fill: "#B5B5BE"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_497_10653)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "compare_arrows",
    d: "M8.66666 21.6673L7.14999 20.1236L9.93957 17.334H2.16666V15.1673H9.93957L7.14999 12.3777L8.66666 10.834L14.0833 16.2507L8.66666 21.6673ZM17.3333 15.1673L11.9167 9.75065L17.3333 4.33398L18.85 5.87773L16.0604 8.66732H23.8333V10.834H16.0604L18.85 13.6236L17.3333 15.1673Z",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatchTransacion);
export default __webpack_public_path__ + "static/media/match-transacion.395bc738967d6fd04d7c7b5de09deaca.svg";
export { ForwardRef as ReactComponent };